module.exports = __webpack_public_path__ + "img/pr-2.a03b7c0a.png";